"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TaxonomyEntityIncomingLists = exports.TaxonomyEntityIncomingListsDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_entities_1 = require("../../hooks/use-entities");
var use_active_person_1 = require("../../hooks/use-active-person");
var current_user_can_1 = require("../../utils/current-user-can");
var entity_list_section_1 = require("./entity-list-section");
var entity_reverse_list_section_1 = require("./entity-reverse-list-section");
exports.TaxonomyEntityIncomingListsDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ListSectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    &:first-child {\n      padding-top: ", ";\n    }\n  "], ["\n    &:first-child {\n      padding-top: ", ";\n    }\n  "])), theme_1.theme.UNIT(4))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  ListSection: (0, styled_components_1.default)(entity_list_section_1.EntityListSection)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ListSectionStyles),
  ReverseListSection: (0, styled_components_1.default)(entity_reverse_list_section_1.EntityReverseListSection)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ListSectionStyles)
};
var TaxonomyEntityIncomingLists = function (props) {
  var className = props.className,
    entity = props.entity;
  var entities = (0, use_entities_1.useEntities)();
  var user = (0, use_active_person_1.useActivePerson)();
  var _a = entity.events,
    events = _a === void 0 ? [] : _a,
    _b = entity.economies,
    economies = _b === void 0 ? [] : _b,
    _c = entity.feedEntries,
    feedEntries = _c === void 0 ? [] : _c,
    _d = entity.locations,
    locations = _d === void 0 ? [] : _d,
    _e = entity.lessons,
    lessons = _e === void 0 ? [] : _e,
    _f = entity.pages,
    pages = _f === void 0 ? [] : _f,
    _g = entity.posts,
    posts = _g === void 0 ? [] : _g,
    _h = entity.teams,
    teams = _h === void 0 ? [] : _h,
    _j = entity.sessions,
    sessions = _j === void 0 ? [] : _j,
    _k = entity.courses,
    courses = _k === void 0 ? [] : _k,
    _l = entity.videos,
    videos = _l === void 0 ? [] : _l;
  return react_1.default.createElement(My.Container, {
    className: className
  }, entities.FeedEntry && (0, current_user_can_1.personCanRead)(user, entities.FeedEntry.scopeSlug) && react_1.default.createElement(My.ReverseListSection, {
    entity: entity,
    maxItems: 5,
    showDescription: true,
    items: feedEntries,
    title: "".concat(entities.FeedEntry.pluralLabel, ":")
  }), entities.Team && (0, current_user_can_1.personCanRead)(user, entities.Team.scopeSlug) && react_1.default.createElement(My.ReverseListSection, {
    entity: entity,
    maxItems: 5,
    showDescription: true,
    items: teams,
    title: "".concat(entities.Team.pluralLabel, ":")
  }), entities.Page && (0, current_user_can_1.personCanRead)(user, entities.Page.scopeSlug) && react_1.default.createElement(My.ReverseListSection, {
    entity: entity,
    maxItems: 5,
    showDescription: true,
    items: pages,
    title: "".concat(entities.Page.pluralLabel, ":")
  }), entities.Post && (0, current_user_can_1.personCanRead)(user, entities.Post.scopeSlug) && react_1.default.createElement(My.ReverseListSection, {
    entity: entity,
    maxItems: 5,
    showDescription: true,
    items: posts,
    title: "".concat(entities.Post.pluralLabel, ":")
  }), entities.Event && (0, current_user_can_1.personCanRead)(user, entities.Event.scopeSlug) && react_1.default.createElement(My.ReverseListSection, {
    entity: entity,
    maxItems: 5,
    showDescription: true,
    items: events,
    title: "".concat(entities.Event.pluralLabel, ":")
  }), entities.Session && (0, current_user_can_1.personCanRead)(user, entities.Session.scopeSlug) && react_1.default.createElement(My.ReverseListSection, {
    entity: entity,
    maxItems: 5,
    showDescription: true,
    items: sessions,
    title: "".concat(entities.Session.pluralLabel, ":")
  }), entities.Course && (0, current_user_can_1.personCanRead)(user, entities.Course.scopeSlug) && react_1.default.createElement(My.ReverseListSection, {
    entity: entity,
    maxItems: 5,
    showDescription: true,
    items: courses,
    title: "".concat(entities.Course.pluralLabel, ":")
  }), entities.Lesson && (0, current_user_can_1.personCanRead)(user, entities.Lesson.scopeSlug) && react_1.default.createElement(My.ReverseListSection, {
    entity: entity,
    maxItems: 5,
    showDescription: true,
    items: lessons,
    title: "".concat(entities.Lesson.pluralLabel, ":")
  }), entities.Economy && (0, current_user_can_1.personCanRead)(user, entities.Economy.scopeSlug) && react_1.default.createElement(My.ReverseListSection, {
    entity: entity,
    maxItems: 5,
    showDescription: true,
    items: economies,
    title: "".concat(entities.Economy.pluralLabel, ":")
  }), entities.Location && (0, current_user_can_1.personCanRead)(user, entities.Location.scopeSlug) && react_1.default.createElement(My.ReverseListSection, {
    entity: entity,
    maxItems: 5,
    showDescription: true,
    items: locations,
    title: "".concat(entities.Location.pluralLabel, ":")
  }), entities.Video && (0, current_user_can_1.personCanRead)(user, entities.Video.scopeSlug) && react_1.default.createElement(My.ReverseListSection, {
    entity: entity,
    maxItems: 5,
    showDescription: true,
    items: videos,
    title: "".concat(entities.Video.pluralLabel, ":")
  }));
};
exports.TaxonomyEntityIncomingLists = TaxonomyEntityIncomingLists;
exports.TaxonomyEntityIncomingLists.defaultProps = exports.TaxonomyEntityIncomingListsDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;